/*
 * 1、平台配置 行542 打开 base:'/page/', //正式环境
 * 
 * 2、router.config.js 
 *   API_BASE_URL = 'http://192.168.1.18/abc/api';    //内网测试环境
 *   API_BASE_URL = 'http://localhost:6800/api';    //本地测试环境
 *   API_BASE_URL = 'http://qlt.liangzili.com.cn/abc/api';//测试环境
 *   API_BASE_URL = 'https://app.liangzili.com.cn/api';//正式环境
 *   
 * 3、config/index.js 行 10-11
 *   assetsPublicPath: '/page/', //环境配置
 * */
//sdscdsfn
import Vue from 'vue'
import Router from 'vue-router'
import { confirmLogin, formatDate } from '@/assets/js/common.js';
import { apiUrl } from '@/router/router.config'
import storeState from '@/store'
const login = r => {
  require.ensure([], () => {
    r(require('@/page/login/login'));
  })
}
const select = r => {
  require.ensure([], () => {
    r(require('@/page/select/select'));
  })
}
//energy首页
const energy = r => {
  require.ensure([], () => {
    r(require('@/page/energy/energy/energy'));
  })
}
const electricalRoom = r => {
  require.ensure([], () => {
    r(require('@/page/energy/energy/electrical_room/electrical_room'));
  })
}
const eCabinetCapacitor = r => {
  require.ensure([], () => {
    r(require('@/page/energy/energy/cabinet-capacitor/cabinet-capacitor'));
  })
}
const eCabinetFeeder = r => {
  require.ensure([], () => {
    r(require('@/page/energy/energy/cabinet-feeder/cabinet-feeder'));
  })
}
const eCabinetIncoming = r => {
  require.ensure([], () => {
    r(require('@/page/energy/energy/cabinet-incoming/cabinet-incoming'));
  })
}
const eCabinetTie = r => {
  require.ensure([], () => {
    r(require('@/page/energy/energy/cabinet-tie/cabinet-tie'));
  })
}
const eTransformer = r => {
  require.ensure([], () => {
    r(require('@/page/energy/energy/transformer/transformer'));
  })
}
//energy能耗分析
const eConsumption = r => {
  require.ensure([], () => {
    r(require('@/page/energy/energyConsumption/energy-consumption'));
  })
}
const ePowerDetail = r => {
  require.ensure([], () => {
    r(require('@/page/energy/energyConsumption/power-detail/power-detail'));
  })
}
const eBranchMonitor = r => {
  require.ensure([], () => {
    r(require('@/page/energy/energyConsumption/branch-monitor/branch-monitor'));
  })
}
//energy个人中心
const eUserAbout = r => {
  require.ensure([], () => {
    r(require('@/page/userCenter/children/about-us/about-us'));
  })
}
const eUserEquipment = r => {
  require.ensure([], () => {
    r(require('@/page/userCenter/children/equipment'));
  })
}
const eUserWiringDiagram = r => {
  require.ensure([], () => {
    r(require('@/page/userCenter/children/wiringDiagram'));
  })
}
const eUserRepsw = r => {
  require.ensure([], () => {
    r(require('@/page/userCenter/set/repsw'));
  })
}
const eUserAlarm = r => {
  require.ensure([], () => {
    r(require('@/page/userCenter/children/alarm/alarm'));
  })
}
const eUserAlarmDetail = r => {
  require.ensure([], () => {
    r(require('@/page/userCenter/children/alarm/alarm-detail'));
  })
}

const eUserAlarmVideo = r => {
  require.ensure([], () => {
    r(require('@/page/userCenter/children/video-alarm/video-alarm'));
  })
}
const eUserVideoDetail = r => {
  require.ensure([], () => {
    r(require('@/page/userCenter/children/video-alarm/video-detail'));
  })
}
//service首页
const service = r => {
  require.ensure([], () => {
    r(require('@/page/service/service'));
  })
}
const sCircuitBreaker = r => {
  require.ensure([], () => {
    r(require('@/page/service/service/circuit-breaker/circuit-breaker'));
  })
}
const sEquipmentInstallation = r => {
  require.ensure([], () => {
    r(require('@/page/service/service/equipment-installation/equipment-installation'));
  })
}
const sEnergyStorage = r => {
  require.ensure([], () => {
    r(require('@/page/service/service/equipment-installation/energy-storage'));
  })
}
const sEvChargingPile = r => {
  require.ensure([], () => {
    r(require('@/page/service/service/equipment-installation/ev-charging-pile'));
  })
}
const sPvPowerStation = r => {
  require.ensure([], () => {
    r(require('@/page/service/service/equipment-installation/pv-power-station'));
  })
}
const sMaintenance = r => {
  require.ensure([], () => {
    r(require('@/page/service/service/maintenance/maintenance'));
  })
}
const sPowerQuality = r => {
  require.ensure([], () => {
    r(require('@/page/service/service/power-quality/power-quality'));
  })
}
const sSmartEp = r => {
  require.ensure([], () => {
    r(require('@/page/service/service/smart-es/smart-ep'));
  })
}
const sSmartEs = r => {
  require.ensure([], () => {
    r(require('@/page/service/service/smart-es/smart-es'));
  })
}
const sSmartEsc = r => {
  require.ensure([], () => {
    r(require('@/page/service/service/smart-es/smart-esc'));
  })
}
const sSmartEse = r => {
  require.ensure([], () => {
    r(require('@/page/service/service/smart-es/smart-ese'));
  })
}
const sSmartEsp = r => {
  require.ensure([], () => {
    r(require('@/page/service/service/smart-es/smart-esp'));
  })
}
const sSmartEss = r => {
  require.ensure([], () => {
    r(require('@/page/service/service/smart-es/smart-ess'));
  })
}
const sTool = r => {
  require.ensure([], () => {
    r(require('@/page/service/service/tool/tool'));
  })
}
//service设置
const sSet = r => {
  require.ensure([], () => {
    r(require('@/page/service/set/set'));
  })
}
const sHelp = r => {
  require.ensure([], () => {
    r(require('@/page/service/set/help'));
  })
}
const sHelpDetail = r => {
  require.ensure([], () => {
    r(require('@/page/service/set/help-detail'));
  })
}
//service完毕

// operation智慧运维
// const oUserMap = r =>require.ensure([], () => {r(require('@/page/operation/user/ma})}
// const oUserCenter = r =>require.ensure([], () => {r(require('@/page/operation/user/user-center/user-cente})}
// const oUserPverify = r =>require.ensure([], () => {r(require('@/page/operation/user/user-center/id_verify/verify_persona})}
// const oUserIdverify = r =>require.ensure([], () => {r(require('@/page/operation/user/user-center/id_verify/id_verif})}
// 首页
const oHomeUser = r => {
  require.ensure([], () => {
    r(require('@/page/operation/home/index-user'));
  })
}
const oHomeElectrician = r => 
{
  require.ensure([], () => {
    r(require('@/page/operation/home/index-electrician'));
  })
}

const oHomeCustomer = r => {
  require.ensure([], () => {
    r(require('@/page/operation/home/index-customer'));
  })
}
//预约相关
const oVLAppoinment = r => {
  require.ensure([], () => {
    r(require('@/page/operation/customerManage/visitList/appoinment'));
  })
}
const oviewListList = r => {
  require.ensure([], () => {
    r(require('@/page/operation/customerManage/visitList/list'));
  })
}
const oviewListIndex = r => {
  require.ensure([], () => {
    r(require('@/page/operation/customerManage/visitList/index'));
  })
}
const oviewListFollow = r => {
  require.ensure([], () => {
    r(require('@/page/operation/customerManage/visitList/follow_list'));
  })
}
// 员工绩效
const oAchievements = r => {
  require.ensure([], () => {
    r(require('@/page/operation/customerManage/achievements'));
  })
}
// 签约相关
const oCMstatistics = r => {
  require.ensure([], () => {
    r(require('@/page/operation/customerManage/contract/statistics'));
  })
}
const oCMtrend = r => {
  require.ensure([], () => {
    r(require('@/page/operation/customerManage/contract/trend'));
  })
}
//日常排班
const oArrangeIndex= r => {
  require.ensure([], () => {
    r(require('@/page/operation/task/Arrange/index'));
  })
}
// const oArrangeDetail= r => {
//   require.ensure([], () => {
//     r(require('@/page/operation/task/Arrange/detail'));
//   })
// }
// 报警 设备报警
const oAlarm = r => {
  require.ensure([], () => {
    r(require('@/page/operation/meter-alarm/index'));
  })
}
const oMeterList = r => {
  require.ensure([], () => {
    r(require('@/page/operation/meter-alarm/meter-list'));
  })
}
const oMeterData = r => {
  require.ensure([], () => {
    r(require('@/page/operation/meter-alarm/meter-data'));
  })
}
const oMeterAdd = r => {
  require.ensure([], () => {
    r(require('@/page/operation/meter-alarm/add-meter'));
  })
}
const oMeterDetail = r => {
  require.ensure([], () => {
    r(require('@/page/operation/meter-alarm/meter-detail'));
  })
}
// 扫描
const oMeterBaicode = r => {
  require.ensure([], () => {
    r(require('@/page/operation/meter-alarm/baicode.vue'));

  })
}
const oMeterNameplate = r => {
  require.ensure([], () => {
    r(require('@/page/operation/meter-alarm/nameplate.vue'));

  })
}
// 个人中心

// 任务处理
const oTaskIndex = r => {
  require.ensure([], () => {
    r(require('@/page/operation/task/index'));
  })
}
const oTaskProcess = r => {
  require.ensure([], () => {
    r(require('@/page/operation/task/task_process'));
  })
}
// 发布任务
const oTaskRelease = r => {
  require.ensure([], () => {
    r(require('@/page/operation/task/TaskRelease/TaskRelease'));
  })
}
const oTaskReleaseSelect = r => {
  require.ensure([], () => {
    r(require('@/page/operation/task/TaskRelease/TaskSelect'));
  })
}
const oTaskReleaseList = r => {
  require.ensure([], () => {
    r(require('@/page/operation/task/TaskRelease/worker_list'));
  })
}
const oTaskREquipmentList = r => {
  require.ensure([], () => {
    r(require('@/page/operation/task/TaskRelease/equipment_list'));
  })
}
const oTaskREContentList = r => {
  require.ensure([], () => {
    r(require('@/page/operation/task/TaskRelease/equipmentContent_list'));
  })
}

const oTaskMap = r => {
  require.ensure([], () => {
    r(require('@/page/operation/task/taskMap'));
  })
}
const otaskNavigation = r => {
  require.ensure([], () => {
    r(require('@/page/operation/task/taskNavigation'));
  })
}
const oReport = r => {
  require.ensure([], () => {
    r(require('@/page/operation/task/report/report'));
  })
}
// 任务流程
const oContactReception = r => {
  require.ensure([], () => {
    r(require('@/page/operation/task/TaskFlow/ContactReception'));
  })
}
const oDeposit = r => {
  require.ensure([], () => {
    r(require('@/page/operation/task/TaskFlow/Deposit'));
  })
}
const oPlaceAttendance = r => {
  require.ensure([], () => {
    r(require('@/page/operation/task/TaskFlow/PlaceAttendance'));
  })
}
const oCostConfirmation = r => {
  require.ensure([], () => {
    r(require('@/page/operation/task/TaskFlow/CostConfirmation'));
  })
}
const oFragmentationDis = r => {
  require.ensure([], () => {
    r(require('@/page/operation/task/TaskFlow/FragmentationDis'));
  })
}
const oStartWork = r => {
  require.ensure([], () => {
    r(require('@/page/operation/task/TaskFlow/StartWork'));
  })
}
const oTaskBindingWork = r => {
  require.ensure([], () => {
    r(require('@/page/operation/task/TaskFlow/BindingWork'));
  })
}
const oTaskCustomerSN = r => {
  require.ensure([], () => {
    r(require('@/page/operation/task/TaskFlow/CustomerSN'));
  })
}
const oTaskItemsSN = r => {
  require.ensure([], () => {
    r(require('@/page/operation/task/TaskFlow/ItemsSN'));
  })
}
const oTaskBinding = r => {
  require.ensure([], () => {
    r(require('@/page/operation/task/TaskFlow/Binding'));
  })
}
//个人中心 
const oUserIndex = r => {
  require.ensure([], () => {
    r(require('@/page/UserCenter/index'));
  })
}
const oUserInfo = r => {
  require.ensure([], () => {
    r(require('@/page/UserCenter/identification/user-info'));
  })
}
const oUserSuggestion = r => {
  require.ensure([], () => {
    r(require('@/page/UserCenter/children/suggestion'));
  })
}
const oUserViewList = r => {
  require.ensure([], () => {
    r(require('@/page/UserCenter/viewList'));
  })
}
// 认证
const oUserIdent = r => {
  require.ensure([], () => {
    r(require('@/page/UserCenter/identification/user-identification'));
  })
}
const oSkillIdent = r => {
  require.ensure([], () => {
    r(require('@/page/UserCenter/identification/skill-identification'));
  })
}
const oCompanyIdent = r => {
  require.ensure([], () => {
    r(require('@/page/UserCenter/identification/company-identification'));
  })
}
// const oAboutUs = r => {
//   require.ensure([], () => {
//     r(require('@/page/UserCenter/aboutUs'));
//   })
// }
// set
const oSetIndex = r => {
  require.ensure([], () => {
    r(require('@/page/UserCenter/set/index'));
  })
}
// const oSInfoNotice = r => {
//   require.ensure([], () => {
//     r(require('@/page/operation/UserCenter/set/infoNotice'));
//   })
// }
const oSUserAgreement = r => {
  require.ensure([], () => {
    r(require('@/page/UserCenter/set/userAgreement'));
  })
}
//help
const oUserHelpIndex = r => {
  require.ensure([], () => {
    r(require('@/page/UserCenter/children/help/index'));
  })
}
const oUserHelpDetail = r => {
  require.ensure([], () => {
    r(require('@/page/UserCenter/children/help/help_detail'));
  })
}
// Notice
const oUserNoticeIndex = r => {
  require.ensure([], () => {
    r(require('@/page/UserCenter/children/notice/index'));
  })
}
const oUserNoticeDetail = r => {
  require.ensure([], () => {
    r(require('@/page/UserCenter/children/notice/notice_detail'));
  })
}
const notFound = r => {
  require.ensure([], () => {
    r(require('@/page/notFound'));
  })
}

Vue.use(Router)
// const scrollBehavior = (to, from, savedPosition) => {
//   if (savedPosition) {
//     // savedPosition is only available for popstate navigations.
//     console.log(1)
//     return savedPosition
//   } else {
//     console.log(2)
//             if (from.meta.keepAlive) {
//                 from.meta.savedPosition = document.body.scrollTop;
//             }
//             return { x: 0, y: to.meta.savedPosition ||0}
//   }
// }
// let URL=''URL=window.location.host+'/page';
const router = new Router({
  mode: 'history',
  base: '/page/', //正式环境
  // scrollBehavior (to, from, savedPosition) {
  //     if (savedPosition) {
  //      console.log(3333);
  //       console.log(savedPosition)
  //       return savedPosition
  //     } else {
  //       return { x: 9, y: 0 }
  //     }
  //   },
  // 设置返回对应位置的操作
  scrollBehavior(to, from, savedPosition) {
    if (savedPosition && to.meta.keepAlive) {
      let scrollTop = store.state.scrollPos || 0
      if (!scrollTop) {
        return
      }
      // 对scroll元素进行设置
      setTimeout(() => {
        let documentElem = document.querySelector('.mint-loadmore')
        if (documentElem) {
          documentElem.scrollTop = scrollTop
        }
      }, 0)
    }
  },
  routes: [
    //operation智慧运维
    //个人中心
    //Notice
    {
      path: '/user/notice/index',
      component: oUserNoticeIndex,
    },
    {
      path: '/user/notice/detail/:id',
      component: oUserNoticeDetail,
    },
    //help
    {
      path: '/user/help/index',
      component: oUserHelpIndex,
    },
    {
      path: '/user/help/detail',
      component: oUserHelpDetail,
    },
    // set
    {
      path: '/user/set/index',
      component: oSetIndex,
    },
    // {
    //   path: '/user/set/InfoNotice',
    //   component: oSInfoNotice,
    // },
    {
      path: '/user/set/UserAgreement',
      component: oSUserAgreement,
    },
    //用户中心
    {
      path: '/user/usercenter',
      component: oUserIndex,
    },
    {
      path: '/user/identification/UserInfo',
      component: oUserInfo,
    },
    {
      path: '/user/suggestion',
      component: oUserSuggestion,
    },
     {
      path: '/user/viewList',
      component: oUserViewList,
    },
    {
      path: '/user/identification/userident',
      component: oUserIdent,
    },
    {
      path: '/user/identification/skillident',
      component: oSkillIdent,
    },
    {
      path: '/user/identification/companyident',
      component: oCompanyIdent,
    },
    // {
    //   path: '/operation/AboutUs',
    //   component: oAboutUs,
    // },
    //用户首页
    {
      path: '/operation/HomeUser',
      component: oHomeUser,
    },

    {
      path: '/operation/HomeElectrician',
      component: oHomeElectrician,
    },

    {
      path: '/operation/HomeCustomer',
      component: oHomeCustomer,
    },
    //预约相关
    {
      path: '/operation/visitList/add',
      component: oVLAppoinment,
    },
    {
      path: '/operation/visitList/list',
      component: oviewListList,
    },
    {
      path: '/operation/visitList/index',
      component: oviewListIndex,
    },
    {
      path: '/operation/visitList/follow_list',
      component: oviewListFollow,
    },
    {
      path: '/operation/customerManage/achievements',
      component: oAchievements,
    },
    // 签约相关
    {
      path: '/operation/contract/statistics',
      component: oCMstatistics,
    },
    {
      path: '/operation/contract/trend',
      component: oCMtrend,
    },
    //日常排班
    {
      path: '/operation/task/Arrange/index',
      component: oArrangeIndex,
    },
    // {
    //   path: '/operation/task/Arrange/detail',
    //   component: oArrangeDetail,
    // },
    // 设备相关  
    {
      path: '/operation/meter/meter-list',
      component: oMeterList,
    },
    {
      path: '/operation/meter/meter-data',
      component: oMeterData,
    },
    {
      path: '/operation/meter/add',
      component: oMeterAdd,
    },
    {
      path: '/operation/meter/meter-detail',
      component: oMeterDetail,
    },
    //扫描
    {
      path: '/operation/meter/baicode',
      component: oMeterBaicode,
    },
    {
      path: '/operation/meter/nameplate',
      component: oMeterNameplate,
    },
    // 报警
    {
      path: '/operation/alarm',
      component: oAlarm,
    },
    // 作业报告
    {
      path: '/operation/report',
      component: oReport,
    },
    // 任务处理
    {
      path: '/operation/Task',
      component: oTaskIndex,
    },
    {
      path: '/operation/TaskProcess',
      component: oTaskProcess,
      // meta: { scrollBehavior: true }
    },
    {
      path: '/operation/TaskRelease',
      name: 'oTaskRelease',
      component: oTaskRelease,
    },
    {
      path: '/operation/TaskRSelect',
      component: oTaskReleaseSelect,
    },
    {
      path: '/operation/TaskRList',
      component: oTaskReleaseList,
    },
    {
      path: '/operation/TaskREContentList',
      name: 'oTaskREContentList',
      component: oTaskREContentList,
    },
    {
      path: '/operation/TREquipmentList/:id',
      name: oTaskREquipmentList,
      component: oTaskREquipmentList,
    },
    {
      path: '/operation/TaskMap',
      component: oTaskMap,
    },
    {
      path: '/operation/TaskNavigation',
      component: otaskNavigation,
    },
    // 任务流程
    {
      path: '/operation/ContactReception/:id',
      component: oContactReception,
    },
    {
      path: '/operation/Deposit/:id',
      component: oDeposit,
    },
    {
      path: '/operation/PlaceAttendance/:id',
      component: oPlaceAttendance,
    },
    {
      path: '/operation/FragmentationDis/:id',
      component: oFragmentationDis,
    },
    {
      path: '/operation/CostConfirmation/:id',
      component: oCostConfirmation,
    },
    {
      path: '/operation/StartWork/:id',
      component: oStartWork,
    },
    {
      path: '/operation/BindingWork/:id',
      component: oTaskBindingWork,
    },
    {
      path: '/operation/CustomerSN/:id',
      component: oTaskCustomerSN,
    },
    {
      path: '/operation/ItemsSN/:id',
      component: oTaskItemsSN,
    },
    {
      path: '/operation/Binding/:id',
      component: oTaskBinding,
    },
    //  //user-center
    //  {
    //    path: '/operation/user',
    //    component: oUserCenter,
    //  },
    //  {
    //    path: '/operation/verify',
    //    component: oUserPverify,
    //  },
    //  {
    //    path: '/operation/verifyInfo',
    //    component: oUserPverify,
    //  },
    //operation智慧运维结束
    //登录界面
    {
      path: '/login',
      component: login
    },
    {
      path: '/select',
      component: select,
      requireAuth: true
    },
    //******energy
    {
      path: '/energy',
      name: 'energy',
      component: energy,
      meta: {
        scrollBehavior: true
      }
    },
    {
      path: '/electrical_room/:id',
      name: 'electricalRoom',
      component: electricalRoom
    },
    {
      path: '/cabinet-capacitor/:id',
      name: 'eCabinetCapacitor',
      component: eCabinetCapacitor
    },
    {
      path: '/cabinet-feeder/:id',
      name: 'eCabinetFeeder',
      component: eCabinetFeeder
    },
    {
      path: '/cabinet-incoming/:id',
      name: 'eCabinetIncoming',
      component: eCabinetIncoming
    },
    {
      path: '/cabinet-tie/:id',
      name: 'eCabinetTie',
      component: eCabinetTie
    },
    {
      path: '/transformer/:id',
      name: 'eTransformer',
      component: eTransformer
    },
    // energy能耗分析
    {
      path: '/energy-consumption',
      name: 'eConsumption',
      component: eConsumption
    },
    {
      path: '/energy-consumption/power-detail/:id',
      component: ePowerDetail
    },
    {
      path: '/energy-consumption/branch-monitor/:id',
      component: eBranchMonitor
    },
    // energy个人中心
    {
      path: '/user/equipment',
      component: eUserEquipment,
    },
    {
      path: '/user/wiringDiagram',
      component: eUserWiringDiagram,
    },
    {
      path: '/user/alarm',
      component: eUserAlarm,
    },
    {
      path: '/user/alarm-detail/:id',
      component: eUserAlarmDetail,
    },
    {
      path: '/user/alarm-video',
      component: eUserAlarmVideo,
    },
    {
      path: '/user/video-detail/:id',
      component: eUserVideoDetail,
    },
    {
      path: '/user/about-us',
      component: eUserAbout,
    },
    {
      path: '/user/repsw',
      component: eUserRepsw,
    },

    // service电力工程服务
    {
      path: '/service/service',
      component: service,
    },
    {
      path: '/service/circuit-breaker',
      component: sCircuitBreaker,
    },
    {
      path: '/service/equipment-installation/energy-storage',
      component: sEnergyStorage,
    },
    {
      path: '/service/equipment-installation',
      component: sEquipmentInstallation,
    },
    {
      path: '/service/equipment-installation/ev-charging-pile/:id',
      component: sEvChargingPile,
    },
    {
      path: '/service/equipment-installation/pv-power-station',
      component: sPvPowerStation,
    },
    {
      path: '/service/maintenance',
      component: sMaintenance,
    },
    {
      path: '/service/power-quality',
      component: sPowerQuality,
    },
    {
      path: '/service/tool',
      component: sTool,
    },
    {
      path: '/service/smart-es/smart-ep',
      component: sSmartEp,
    },
    {
      path: '/service/smart-es',
      component: sSmartEs,
    },
    {
      path: '/service/smart-es/smart-esc',
      component: sSmartEsc,
    },
    {
      path: '/service/smart-es/smart-ese',
      component: sSmartEse,
    },
    {
      path: '/service/smart-es/smart-esp',
      component: sSmartEsp,
    },
    {
      path: '/service/smart-es/smart-ess',
      component: sSmartEss,
    },
    //service设置页面
    {
      path: '/service/set',
      component: sSet,
    },
    {
      path: '/service/set/help',
      component: sHelp,
    },
    {
      path: '/service/set/help-detail/:id',
      component: sHelpDetail,
    },
    {
      path: '/',
      //      meta: {
      //        //添加该字段，表示进入这个路由是需要登录的
      //        requireAuth:true,
      //      },
      //    redirect: '/select',
      beforeEnter: (to, from, next) => {
        var value = 0;
        if (to.query.t) {
          value = to.query.t;
        }
        storeState.commit({
          type: "setState",
          attr: 'APP_TYPE',
          value: value,
          storeFlag: 1
        });
        if (store.get('user') && store.get('user').token) {
          var json = {
            "loginStatus": true, //true去判断有没有登录，false，不去判断登录
            "token": store.get('user') ? store.get('user').token : "",
            "UserID": store.get('user') ? store.get('user').user_id : "", //移动设备的唯一标识号。
            "UUID": "",
            "AppName": "", //app名字
            "AppVersion": "", //APP版本
            "Page": from.path, //上一个页面
            "Address": to.path, //这个当前页面
            "StartTime": formatDate(new Date(), 'yyyy-MM-dd hh:mm:ss.S'),
            "LogLevel": "debug"
          }
          $.ajax({
            type: 'POST',
            url: apiUrl() + '/alive',
            dataType: "json",
            contentType: 'application/json',
            data: JSON.stringify(json),
            success: function(data, status) {
              if (data.state != 'SUCCESS') {
                store.remove('user');
							storeState.commit({
								type: "setState",
								attr: 'oTaskReleaseContent',
								value: {
									oTaskType: '',
									oTRcompany: '',
									oTaskname: '',
									oTRarchiveArr: '',
									oTRarchiveItemArr: '',
									oTRImages: [],
									oTRtime: '',
                  oTRcontent: '',
                  projecter:'' //负责人
								}
							});
							storeState.commit({
								type: "setState",
								attr: 'companyInfo',
								value: '',
								storeFlag: 1
							});
                next({
                  path: '/login'
                });
              } else {
                next({
                  path: '/select'
                });
              }
            }
          });
        } else {
          next({
            path: '/login'
          });
        }
      }
    },
    {
      path: '*',
      component: notFound,
      meta: {
        title: '404未找到',
      },
    },
  ]
})

let url = window.location.host + '/page';

let FromPath = ''; //防止一直发送日志造成http卡顿
let ToPath = '';//防止一直发送日志造成http卡顿
let t1 = new Date();
router.beforeEach((to, from, next) => {
  if (to.path != "/login" && to.path != "/" && FromPath != from.path && ToPath != to.path) {
    FromPath = from.path;
    ToPath = to.path;     
    confirmLogin(url + FromPath, url + ToPath,'debug',t1);
    t1 = new Date();
  }
  next();
})
// router.afterEach((to, from, next) => {
//  var next=next;
//  console.log(next);
//  console.log(to.matched.some(record => record.meta.requireAuth));
//  if (to.matched.some(record => record.meta.requireAuth)){
//  if (store.get('user') && store.get('user').token) {
//           $.ajax({
//             type: 'post',
//             url: apiUrl() + '/alive?token=' + store.get('user').token + '&uuid=' + store.get('user').uuid,
//             contentType: 'application/json',
//             success: function(data, status) {
//               if (data.state != 'SUCCESS') {
//                if(!next){
//                   window.location.href = '/login'
//                  }else{
//                    next({ path: '/select', query: {redirect: to.fullPath}});
//                  }
//               } else {
//                 if(next){next();}
//               }
//             }
//           });
//         } else {
//           next({ path: '/login', query: {redirect: to.fullPath}  });
//         }
// }else{
//  next({path: '/select', query: {redirect: to.fullPath} });
// }

// });
export default router;



// WEBPACK FOOTER //
// ./src/router/index.js